import React from 'react';
import PropTypes from 'prop-types';
import ZImage from 'sushiweb/ZImage/ZImage';
import { AWW_SNAP_IMG } from '../../../../../constants/images';
import { DataFetchError, Title } from '../styles';
import { EMPTY_DATA } from '../constants';

const EmptyData = ({ emptyStateTitle }) => {
  return (
    <DataFetchError className='center'>
      <ZImage
        src={AWW_SNAP_IMG}
        width='19rem'
        height='18rem'
        fit='contain'
        alt='aww snap'
      />
      <Title>{emptyStateTitle !== '' ? emptyStateTitle : EMPTY_DATA}</Title>
    </DataFetchError>
  );
};

EmptyData.propTypes = {
  emptyStateTitle: PropTypes.string,
};

EmptyData.defaultProps = {
  emptyStateTitle: '',
};

export default EmptyData;
